<div class="create-customer-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Create New Customer</h1>
        <p>Add a new customer with their details and addresses</p>
      </div>
      <a routerLink="/customers" class="back-btn" (click)="onCancel()">
        <i class="fas fa-arrow-left"></i> Back to Customers
      </a>
    </div>
  </div>

  <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="customer-form">
    <!-- Customer Basic Details -->
    <div class="form-section">
      <h2>Customer Information</h2>
      
      <div class="form-row">
        <div class="form-group">
          <label for="name">Full Name *</label>
          <input 
            type="text" 
            id="name" 
            formControlName="name" 
            placeholder="Enter customer's full name"
            [class.error]="customerForm.get('name')?.invalid && customerForm.get('name')?.touched">
          <div class="error-message" *ngIf="customerForm.get('name')?.invalid && customerForm.get('name')?.touched">
            {{ getErrorMessage('name') }}
          </div>
        </div>

        <div class="form-group">
          <label for="phoneNumber">Phone Number *</label>
          <input 
            type="tel" 
            id="phoneNumber" 
            formControlName="phoneNumber" 
            (input)="onPhoneNumberInput($event)"
            placeholder="+91 00000 00000"
            maxlength="17"
            [class.error]="customerForm.get('phoneNumber')?.invalid && customerForm.get('phoneNumber')?.touched">
          <div class="error-message" *ngIf="customerForm.get('phoneNumber')?.invalid && customerForm.get('phoneNumber')?.touched">
            {{ getErrorMessage('phoneNumber') }}
          </div>
        </div>
      </div>
    </div>

    <!-- Addresses Section -->
    <div class="form-section">
      <div class="section-header">
        <h2>Customer Addresses</h2>
        <button type="button" class="add-address-btn" (click)="addAddress()">
          <i class="fas fa-plus"></i> Add Address
        </button>
      </div>

      <div class="addresses-container" *ngIf="addresses.length > 0">
        <div class="address-card" *ngFor="let address of addresses.controls; let i = index" [formGroup]="address">
          <div class="address-header">
            <h3>Address {{ i + 1 }}</h3>
            <div class="address-actions">
              <button 
                type="button" 
                class="primary-btn"
                [class.active]="address.get('isPrimary')?.value"
                (click)="setPrimaryAddress(i)">
                {{ address.get('isPrimary')?.value ? 'Primary' : 'Set as Primary' }}
              </button>
              <button 
                type="button" 
                class="remove-btn"
                (click)="removeAddress(i)">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>

          <div class="address-fields">
            <div class="form-row">
              <div class="form-group">
                <label>Address *</label>
                <textarea 
                  formControlName="address" 
                  placeholder="Enter complete address"
                  rows="3"
                  [class.error]="address.get('address')?.invalid && address.get('address')?.touched">
                </textarea>
                <div class="error-message" *ngIf="address.get('address')?.invalid && address.get('address')?.touched">
                  Address is required
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Location Name *</label>
                <input 
                  type="text" 
                  formControlName="locationName" 
                  placeholder="City, Area, Landmark"
                  [class.error]="address.get('locationName')?.invalid && address.get('locationName')?.touched">
                <div class="error-message" *ngIf="address.get('locationName')?.invalid && address.get('locationName')?.touched">
                  Location name is required
                </div>
              </div>

              <div class="form-group">
                <label>Pincode *</label>
                <input 
                  type="text" 
                  formControlName="pincode" 
                  placeholder="6-digit pincode"
                  maxlength="6"
                  [class.error]="address.get('pincode')?.invalid && address.get('pincode')?.touched">
                <div class="error-message" *ngIf="address.get('pincode')?.invalid && address.get('pincode')?.touched">
                  {{ getErrorMessage('customerAddress', 'pincode') }}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group">
                <label>Address Type</label>
                <select formControlName="addressType">
                  <option value="">-- Select Address Type (Optional) --</option>
                  <option value="Home">Home</option>
                  <option value="Office">Office</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            <!-- Location Coordinates -->
            <div class="form-row">
              <div class="form-group">
                <label for="latitude">Latitude *</label>
                <input 
                  type="number" 
                  id="latitude"
                  formControlName="latitude" 
                  placeholder="Enter latitude (e.g., 8.568565)"
                  step="any"
                  [class.error]="address.get('latitude')?.invalid && address.get('latitude')?.touched">
                <div class="error-message" *ngIf="address.get('latitude')?.invalid && address.get('latitude')?.touched">
                  {{ getErrorMessage('customerAddress', 'latitude') }}
                </div>
              </div>

              <div class="form-group">
                <label for="longitude">Longitude *</label>
                <input 
                  type="number" 
                  id="longitude"
                  formControlName="longitude" 
                  placeholder="Enter longitude (e.g., 76.865612)"
                  step="any"
                  [class.error]="address.get('longitude')?.invalid && address.get('longitude')?.touched">
                <div class="error-message" *ngIf="address.get('longitude')?.invalid && address.get('longitude')?.touched">
                  {{ getErrorMessage('customerAddress', 'longitude') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="no-addresses" *ngIf="addresses.length === 0">
        <p>No addresses added yet. Click "Add Address" to get started.</p>
      </div>
    </div>

    <!-- Submit Section -->
    <div class="form-actions">
      <button 
        type="submit" 
        class="submit-btn"
        [disabled]="customerForm.invalid || isSubmitting">
        <i class="fas fa-save"></i>
        {{ isSubmitting ? 'Creating Customer...' : 'Create Customer' }}
      </button>
    </div>
  </form>


</div> 